/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Seek direction for trick-play operations.
 */
export enum Direction {
  Forward = 1,
  Backward = -1
}
